<template>
  <v-container fluid>
    <v-dialog
      v-model="dialog2"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card>
        <v-card-title class="text-h5 primary">
          <v-btn
            icon
            dark
            @click="dialog2 = false"
          >
            <v-icon>{{ icons.mdiClose }}</v-icon>
          </v-btn>  Service {{ service.hotel_name }}
        </v-card-title>
        <v-card-text class="pt-4">
          <GetServiceHotel
            :hotel="service"
            :date="this.date"
          ></GetServiceHotel>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog2 = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-data-table
      :headers="dessertHeaders"
      :items="desserts"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      :search="search"
      item-key="id_hotel"
      show-expand
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Hotel Data</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            solo
            dense
            append-icon="mdi-magnify"
            label="Search Hotel Data"
            class="mr-3 white"
            outlined
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <v-row>
            <v-col
              cols="12"
              md="5"
            >
              <v-simple-table>
                <tbody>
                  <tr>
                    <td>Region</td>
                    <td>: {{ item.region }}</td>
                  </tr>
                  <tr>
                    <td>Contact Person</td>
                    <td>: {{ item.contact_person_name }}</td>
                  </tr>
                  <tr>
                    <td>Contact Position</td>
                    <td>: {{ item.contact_person_position }}</td>
                  </tr>
                  <tr>
                    <td>Contact Email</td>
                    <td>: {{ item.contact_person_email }}</td>
                  </tr>
                  <tr>
                    <td>Website</td>
                    <td>: {{ item.website }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
            <v-col>
              <v-simple-table>
                <tbody>
                  <tr>
                    <td>Notes</td>
                    <td colspan="2">
                      : {{ item.notes }}
                    </td>
                  </tr>
                  <tr>
                    <td>Contract Valid Start</td>
                    <td
                      colspan="2"
                      rowspan="1"
                    >
                      : {{ item.start }}
                    </td>
                  </tr>
                  <tr>
                    <td>Contract Valid End</td>
                    <td colspan="2">
                      : {{ item.end }}
                    </td>
                  </tr>
                  <tr>
                    <td>Total Service</td>
                    <td>: {{ Number(item.total_service).toLocaleString() }} </td>
                    <td>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>
        </td>
      </template>
      <template #[`item.contract`]="{ item }">
        <v-chip
          :color="getColor(item.contract_valid_end,item.contract_valid_start)"
          dark
          v-text="CountContract(item.contract_valid_end,item.contract_valid_start)"
        >
        </v-chip>
      </template>
      <template #[`item.actions`]="{ item }">
        <v-btn
          block
          right
          class="primary text-capitalize"
          small
          @click="OpenService(item)"
        >
          Service <v-icon>{{ icons.mdiEye }}</v-icon>
        </v-btn>
      </template>
      <template v-slot:no-data>
        <v-btn
          color="primary"
          @click="initialize"
        >
          Reset
        </v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
import axios from 'axios'
import {
  mdiPencil,
  mdiTrashCan,
  mdiPlus,
  mdiClose,
  mdiCalendar,
  mdiEye,
} from '@mdi/js'
import GetServiceHotel from './get-service-hotel.vue'

export default {
  components: { GetServiceHotel },
  props: ['date'],
  data() {
    return {
      icons: {
        mdiPencil,
        mdiTrashCan,
        mdiPlus,
        mdiClose,
        mdiCalendar,
        mdiEye,
      },
      modal: false,
      modal5: false,
      expanded: [],
      singleExpand: true,
      dialog: false,
      dialog2: false,
      editedIndex: -1,
      search: '',
      form: {
        contact_person_email: '',
        contact_person_name: '',
        star_kategory: '',
        contact_person_position: '',
        contract_valid_start: '2022-01-01',
        contract_valid_end: '2022-01-01',
        email: '',
        hotel_name: '',
        id_hotel: '',
        phone: '',
        region: '',
        website: '',
        notes: '',
      },
      service: [],
      dessertHeaders: [
        { text: 'Hotel Name', value: 'hotel_name' },
        { text: 'Region', value: 'region_name' },
        { text: 'Star', value: 'star_kategory' },
        { text: 'Phone', value: 'phone' },
        { text: 'Email', value: 'email' },
        { text: 'Contract', value: 'contract' },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
          width: 200,
        },
      ],
      desserts: [],
      dataservice: [],
      datenow: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Add New Hotel' : 'Edit Hotel'
    },
    TittleButton() {
      return this.editedIndex === -1 ? 'Save Hotel' : 'Update Hotel'
    },
  },

  mounted() {
    this.initialize()
  },
  methods: {
    getColor(end, start) {
      if (this.datenow < start) {
        return 'warning'
      } if (this.datenow > end) {
        return 'error'
      }

      return 'primary'
    },
    CountContract(end, start) {
      if (this.datenow < start) {
        return 'Valid Soon'
      } if (this.datenow > end) {
        return 'Expired'
      }

      return 'Valid'
    },
    CekDialog() {
      this.form = {
        contact_person_email: '',
        contact_person_name: '',
        star_kategory: '',
        contact_person_position: '',
        contract_valid_start: '2022-01-01',
        contract_valid_end: '2022-01-01',
        email: '',
        hotel_name: '',
        id_hotel: '',
        phone: '',
        region: '',
        website: '',
        notes: '',
      }
      this.dialog = false
    },
    OpenService(item) {
      this.service = item
      this.dialog2 = true
    },
    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item)
      this.form = item
      this.dialog = true
    },
    deleteItem(item) {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/DeleteHotel', item).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.initialize()
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    initialize() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.get('auth/Hotel').then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.desserts = response.data.data
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    Save() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/SaveHotel', this.form).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.initialize()
        this.dialog = false
        this.CekDialog()
        this.editedIndex = -1
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
  },
}
</script>
